import { api } from './api'
import type { CreditBalances, CreditLedgerEntry, NotificationChannel } from '@riverpark/types'

export async function getCreditBalances(): Promise<{ data: CreditBalances }> {
  return api.get<{ data: CreditBalances }>('/credits/balance')
}

export async function listCreditLedger(
  channel: NotificationChannel,
): Promise<{ data: CreditLedgerEntry[] }> {
  return api.get<{ data: CreditLedgerEntry[] }>(`/credits/ledger?channel=${channel}`)
}

export interface TopUpCreditsInput {
  channel: NotificationChannel
  amount: number
  reason: string
}

export async function topUpCredits(input: TopUpCreditsInput): Promise<{ data: CreditBalances }> {
  return api.post<{ data: CreditBalances }>('/credits/top-up', input)
}
